export default "__VITE_ASSET__Qwd54R3a__"